import React, { useState, useEffect } from "react"

import { Row, Col, Input, Switch, Select, Space } from "antd"
import BulletPointTicket from "./components/BulletPointNew"
import couriers from "images/landing-page/couriers.png"
import dpd from "images/landing-page/dpd-bubble.png"
import postnl from "images/landing-page/postnl-bubble.png"
import fedex from "images/landing-page/fedex-bubble.png"
import ups from "images/landing-page/ups-bubble.png"
import gls from "images/landing-page/gls-bubble.png"
import dhl from "images/landing-page/dhl-bubble.png"
import omniva from "images/landing-page/omniva-bubble.png"
import tnt from "images/landing-page/tnt-bubble.png"
import siusk24 from "images/landing-page/siusk24.png"
import Aos from "aos"
import BulletPoint from "images/v2/alsendo-point.svg"
import globeImage from "images/landing-page/globe.png"
import "aos/dist/aos.css"
import HeroCarousel from "./HeroCarousel"
import { useMediaQuery } from "react-responsive"

const bulletPoints = [
  "Siuntos į daugiau nei 200 šalių",
  "Pristatymas nuo durų iki durų",
  "Paštomatų paslaugos siunčiant siuntas į užsienį",
  "Pristatymas į užsienį nuo 2 d.d. iki 9 d.d. ",
]


const CourierSection = () => {
  const isMobileScreen = useMediaQuery({ query: "(max-width: 992px)" })

  useEffect(() => {
    setInterval(() => {

    }, 50)
  }, [])


  return (
    <>
      <Row
        gutter={{ lg: 16 }}
        align="middle"
        style={{
          backgroundColor: "#F7F7F7",
          paddingBottom: "50px",
          paddingTop: "20px" 
        }}
        className="front-page-section"
      >
        <Col span={24} style={{ marginBottom: "30px" }}>
          <HeroCarousel />
        </Col>
        <Col order={0} span={24} lg={{ span: 8, offset: 4, order: 0 }}>
          <div
            style={{
              display: "flex",
              justifyContent: isMobileScreen ? "center" : "start",
            }}
          >
            <div data-aos={isMobileScreen ? "" : "fade-right"}>
              <img
                src={globeImage}
                style={{
                  width: "100%",
                  maxWidth: "300px",
                  marginTop: isMobileScreen && 30,
                  marginRight: !isMobileScreen && 60,
                }}
              />
            </div>
          </div>
        </Col>
        <Col span={24} lg={{ span: 12 }}>
          <div
            style={{ width: "100%", display: "flex", justifyContent: isMobileScreen ? "center" : "start" }}
          >
            <div
              data-aos={isMobileScreen ? "" : "flip-right"}
              style={{
                maxWidth: 600,
              }}
            >
              <div className="section-title" style={{ marginTop: "75px" }}>
                {"Platus kurjerių tinklas visame pasaulyje!"}
              </div>

              <div
                className="section-sub-title"
                style={{ marginTop: "18px", marginBottom: "5px" }}
              >
                {
                  "Patikimiausių ir žinomiausių kurjerių kompanijų paslaugos vienoje vietoje"
                }
              </div>
              
              {bulletPoints.map((point, index) => (
                <div className="section-bullet-point" key={index}>
                  <Space size="small" style={{ alignItems: "center" }}>
                    <BulletPointTicket />
                    <div>{point}</div>
                  </Space>
                </div>
              ))}
              
            </div>
          </div>
        </Col>

       
      </Row>
    </>
  )
}

export default CourierSection
